require("ci5/smart_form");

(function ($) {
  $.widget("barclays.smart_form", $.chopin.smart_form, {
    options: {
      animateHelp: true,
    },
  });
})(window.jQuery);
